var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"loading-skeleton"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Carregando lista"}})])])])
}]

export { render, staticRenderFns }